import React, { useEffect, useState, useRef } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// // import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  // setShowShareBtn,
  haUserId,
  haAccessToken,
  haMemberMissionId,
  setCompletionMessage,
  setIsDkabio,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 需要登入嗎
  const requiresLogin = {
    login: true,
    title: '驗證碼',
    placeholder: '0900000000',
    alert: '資訊錯誤，請聯繫 HR 以更新問卷狀態',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(3)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)
  agreeSurvey.onCurrentPageChanged.add(function (survey, options) {
    // 切換頁面時滾動到頂部
    window.scrollTo(0, 0)
  })
  useEffect(() => {
    setCompletionMessage(
      `<h4 style="text-align:center">謝謝您的填寫！問卷已成功送出。</h4><p>分析報告完成後 DKABio 將通知 HR，屆時請您登入 HA! 健康 App 查看並下載個人 DKABio 智慧健康風險分析報告。若對於 DKABio 智慧健康風險服務有任何問題，歡迎透過 DKABio 官方 Line(ID：@dkabio)客服詢問，將由專人為您服務。</p>`
    )
  }, [])

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列
  // const visibleIfConditionsInit = {
  //   q1: '{q0} = 0',
  // }

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [19]
  const notRequired = null

  // 尺規選項
  // const rateChoice = [
  //   { min: '(不是一個快樂的人)', max: '(是一個非常快樂的人)' },
  //   { min: '(比較不快樂)', max: '(比較快樂)' },
  //   { min: '(完全不能)', max: '(完全可以)' },
  //   { min: '(完全不能)', max: '(完全可以)' },
  // ]

  // const mappedRateChoice = rateChoice.map((v) => {
  //   return [
  //     {
  //       value: 1,
  //       text: '1 ' + v.min,
  //     },
  //     2,
  //     3,
  //     4,
  //     5,
  //     6,
  //     7,
  //     {
  //       value: 7,
  //       text: '7 ' + v.max,
  //     },
  //   ]
  // })
  const mappedRateChoice = null
  // const pageBreakQuestions = ['q2', 'q11', 'q15']
  const pageBreakQuestions = null
  const triggersConditionsInit = null

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    // serial_num,
    bringOptionsMapRef,
    haUserId,
    haAccessToken,
    haMemberMissionId,
  })

  // console.log('haUserId', haUserId)

  const newSurvey = new Model(convertedSurvey)
  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  function helpFunction(survey, options) {
    // 參考 P231113152849 或 P231101165555
  }

  const canShowPrevButtonPages = null

  useSubmitAnswers({
    survey: newSurvey,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    // setShowShareBtn,
    bringOptionsMapRef,
    haAccessToken,
    haMemberMissionId,
    setIsDkabio,
  })

  // const completedPageElement = document.querySelector('.sd-completedpage')
  // useEffect(() => {
  //   if (completedPageElement) {
  //     setShowShareBtn(true)
  //     console.log('5566')
  //   }
  // }, [newSurvey])

  return (
    <>
      {convertedSurvey ? (
        <>
          <Survey model={newSurvey} />
        </>
      ) : myAgreeJson ? (
        <>
          <Survey model={agreeSurvey} />
        </>
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
